import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { PdfViewerModalComponent } from '../../../pdf-viewer-modal/pdf-viewer-modal.component';
import { CancellationMetadataComponentAbstract } from '../../metadata-components/cancellation-metadata/cancellation-metadata.component.abstract';

@Component({
  selector: 'app-cancellation-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent, IconsModule, PdfViewerModalComponent],
  templateUrl: './cancellation-metadata-v2.component.html',
  styleUrls: ['./cancellation-metadata-v2.component.css'],
})
export class CancellationMetadataV2Component extends CancellationMetadataComponentAbstract {}
